import _ from "lodash";
import {REQUEST_SUCCESS} from "../request/requestActions";
import {CATALOG_FETCH} from "../../state/catalog/catalogActions";
import {
  DETAIL_LEVEL_SET,
  setDetailLevel,
  setDetailLevelFilteredCatalog
} from "../../state/detail-level/detailLevelActions";
import {setRedirectUrl} from "../../state/miscellaneous/miscellaneousActions";
import {INIT} from "../../state/rootActions";
import {getDatasetFromCatalog, getFilteredCatalog} from "../../utils/catalog";
import {isValidIntegerInInclusiveRange} from "../../utils/validator";

const detailLevelMiddleware =
  ({getState, dispatch}) =>
  next =>
  action => {
    const res = next(action);

    if (action.type === INIT) {
      dispatch(setDetailLevel(action.payload.detailLevel));
    }

    if (action.type === DETAIL_LEVEL_SET) {
      window.detailLevel = action.payload.detailLevel;

      const params = new URLSearchParams(window.location.search);

      let detailLevelParam = params.get("t") ? decodeURIComponent(params.get("t")) : null;
      if (isValidIntegerInInclusiveRange(detailLevelParam)) {
        detailLevelParam = parseInt(detailLevelParam, 10);
      } else {
        detailLevelParam = null;
      }

      if (detailLevelParam !== action.payload.detailLevel) {
        if (action.payload.detailLevel !== null) {
          params.set("t", encodeURIComponent(action.payload.detailLevel));
        } else {
          params.delete("t");
        }
        const paramsStr = params.toString();

        const clientBasePath = getState()?.config?.clientBasePath || "";
        const locationPathname = window.location.pathname.replace(clientBasePath, "");
        dispatch(setRedirectUrl(locationPathname + (paramsStr.length > 0 ? `?${paramsStr}` : "")));
      }
    }

    if (
      action.type === DETAIL_LEVEL_SET ||
      (action.type === REQUEST_SUCCESS && action.payload.label === CATALOG_FETCH)
    ) {
      const {catalog} = getState();
      let detailLevel =
        action.payload.detailLevel !== undefined ? action.payload.detailLevel : getState().detailLevel.detailLevel;

      let datasets;
      if (catalog) {
        const catalogDetailLevels = catalog.detailLevels.map(({id}) => id);
        datasets = _.cloneDeep(catalog.packageMap);
        if (detailLevel !== null) {
          if (catalogDetailLevels.includes(detailLevel)) {
            datasets = {};
            Object.keys(catalog.packageMap)
              .filter(packageId => {
                const dataset = getDatasetFromCatalog(packageId, catalog);
                return (dataset?.detailsLevels || []).includes(detailLevel);
              })
              .forEach(id => (datasets[id] = catalog.packageMap[id]));
          } else {
            detailLevel = null;
            dispatch(setDetailLevel(detailLevel));
          }
        }
      }

      const filteredCatalog =
        catalog && detailLevel !== null
          ? getFilteredCatalog(catalog, packageId => {
              const dataset = getDatasetFromCatalog(packageId, catalog);
              return (dataset?.detailsLevels || []).includes(detailLevel);
            })
          : catalog;

      dispatch(setDetailLevelFilteredCatalog(filteredCatalog));
    }

    return res;
  };

export default detailLevelMiddleware;
